import { render, staticRenderFns } from "./CancellationRefundAmounts.vue?vue&type=template&id=f08e31a6&scoped=true&"
import script from "./CancellationRefundAmounts.vue?vue&type=script&lang=js&"
export * from "./CancellationRefundAmounts.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRefundAmounts.vue?vue&type=style&index=0&id=f08e31a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e31a6",
  null
  
)

export default component.exports